/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as AuthedIndexRouteImport } from './routes/_authed.index'
import { Route as ResetPasswordTokenRouteImport } from './routes/reset-password.$token'
import { Route as AuthedTeamRouteImport } from './routes/_authed.team'
import { Route as AuthedTasksRouteImport } from './routes/_authed.tasks'
import { Route as AuthedSettingsRouteImport } from './routes/_authed.settings'
import { Route as AuthedScreenshotsRouteImport } from './routes/_authed.screenshots'
import { Route as AuthedSchemasRouteImport } from './routes/_authed.schemas'
import { Route as AuthedReportsRouteImport } from './routes/_authed.reports'
import { Route as AuthedPlanesRouteImport } from './routes/_authed.planes'
import { Route as AuthedPipelinesRouteImport } from './routes/_authed.pipelines'
import { Route as AuthedOportunidadesBandejaRouteImport } from './routes/_authed.oportunidades-bandeja'
import { Route as AuthedOportunidadesRouteImport } from './routes/_authed.oportunidades'
import { Route as AuthedInboxRouteImport } from './routes/_authed.inbox'
import { Route as AuthedGoogleAdsRouteImport } from './routes/_authed.google-ads'
import { Route as AuthedCrmRouteImport } from './routes/_authed.crm'
import { Route as AuthedContactsRouteImport } from './routes/_authed.contacts'
import { Route as AuthedCmsRouteImport } from './routes/_authed.cms'
import { Route as AuthedClientesRouteImport } from './routes/_authed.clientes'
import { Route as AuthedChatbotRouteImport } from './routes/_authed.chatbot'
import { Route as AuthedAutomationsRouteImport } from './routes/_authed.automations'
import { Route as AuthedAgendaRouteImport } from './routes/_authed.agenda'
import { Route as AuthedAdminsRouteImport } from './routes/_authed.admins'
import { Route as AgendaGestionarTokenRouteImport } from './routes/agenda.gestionar.$token'
import { Route as AgendaTenantSlugRouteImport } from './routes/agenda.$tenant.$slug'
import { Route as AuthedOportunidadesLeadIdRouteImport } from './routes/_authed.oportunidades_.$leadId'
import { Route as AuthedContactsContactIdRouteImport } from './routes/_authed.contacts_.$contactId'
import { Route as AuthedConfiguracionCorreoRouteImport } from './routes/_authed.configuracion.correo'
import { Route as AuthedConfiguracionAgentesRouteImport } from './routes/_authed.configuracion.agentes'
import { Route as AuthedClientesIdRouteImport } from './routes/_authed.clientes_.$id'
import { Route as AuthedAutomationsTemplatesRouteImport } from './routes/_authed.automations.templates'
import { Route as AuthedAutomationsFormsRouteImport } from './routes/_authed.automations.forms'
import { Route as AuthedAutomationsFlowsRouteImport } from './routes/_authed.automations.flows'
import { Route as AuthedAgendaNuevaRouteImport } from './routes/_authed.agenda_.nueva'
import { Route as AuthedAgendaPageIdRouteImport } from './routes/_authed.agenda_.$pageId'
import { Route as AuthedAutomationsTemplatesNewRouteImport } from './routes/_authed.automations.templates_.new'
import { Route as AuthedAutomationsTemplatesTemplateIdRouteImport } from './routes/_authed.automations.templates_.$templateId'
import { Route as AuthedAutomationsFormsNewRouteImport } from './routes/_authed.automations.forms_.new'
import { Route as AuthedAutomationsFormsFormIdRouteImport } from './routes/_authed.automations.forms_.$formId'
import { Route as AuthedAutomationsFlowsNewRouteImport } from './routes/_authed.automations.flows_.new'
import { Route as AuthedAutomationsFlowsFlowIdRouteImport } from './routes/_authed.automations.flows_.$flowId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const ResetPasswordTokenRoute = ResetPasswordTokenRouteImport.update({
  id: '/reset-password/$token',
  path: '/reset-password/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedTeamRoute = AuthedTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTasksRoute = AuthedTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsRoute = AuthedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedScreenshotsRoute = AuthedScreenshotsRouteImport.update({
  id: '/screenshots',
  path: '/screenshots',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSchemasRoute = AuthedSchemasRouteImport.update({
  id: '/schemas',
  path: '/schemas',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedReportsRoute = AuthedReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPlanesRoute = AuthedPlanesRouteImport.update({
  id: '/planes',
  path: '/planes',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPipelinesRoute = AuthedPipelinesRouteImport.update({
  id: '/pipelines',
  path: '/pipelines',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedOportunidadesBandejaRoute =
  AuthedOportunidadesBandejaRouteImport.update({
    id: '/oportunidades-bandeja',
    path: '/oportunidades-bandeja',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedOportunidadesRoute = AuthedOportunidadesRouteImport.update({
  id: '/oportunidades',
  path: '/oportunidades',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedInboxRoute = AuthedInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedGoogleAdsRoute = AuthedGoogleAdsRouteImport.update({
  id: '/google-ads',
  path: '/google-ads',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCrmRoute = AuthedCrmRouteImport.update({
  id: '/crm',
  path: '/crm',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedContactsRoute = AuthedContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCmsRoute = AuthedCmsRouteImport.update({
  id: '/cms',
  path: '/cms',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedClientesRoute = AuthedClientesRouteImport.update({
  id: '/clientes',
  path: '/clientes',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedChatbotRoute = AuthedChatbotRouteImport.update({
  id: '/chatbot',
  path: '/chatbot',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAutomationsRoute = AuthedAutomationsRouteImport.update({
  id: '/automations',
  path: '/automations',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAgendaRoute = AuthedAgendaRouteImport.update({
  id: '/agenda',
  path: '/agenda',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminsRoute = AuthedAdminsRouteImport.update({
  id: '/admins',
  path: '/admins',
  getParentRoute: () => AuthedRoute,
} as any)
const AgendaGestionarTokenRoute = AgendaGestionarTokenRouteImport.update({
  id: '/agenda/gestionar/$token',
  path: '/agenda/gestionar/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AgendaTenantSlugRoute = AgendaTenantSlugRouteImport.update({
  id: '/agenda/$tenant/$slug',
  path: '/agenda/$tenant/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedOportunidadesLeadIdRoute =
  AuthedOportunidadesLeadIdRouteImport.update({
    id: '/oportunidades_/$leadId',
    path: '/oportunidades/$leadId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedContactsContactIdRoute = AuthedContactsContactIdRouteImport.update({
  id: '/contacts_/$contactId',
  path: '/contacts/$contactId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedConfiguracionCorreoRoute =
  AuthedConfiguracionCorreoRouteImport.update({
    id: '/configuracion/correo',
    path: '/configuracion/correo',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedConfiguracionAgentesRoute =
  AuthedConfiguracionAgentesRouteImport.update({
    id: '/configuracion/agentes',
    path: '/configuracion/agentes',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedClientesIdRoute = AuthedClientesIdRouteImport.update({
  id: '/clientes_/$id',
  path: '/clientes/$id',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAutomationsTemplatesRoute =
  AuthedAutomationsTemplatesRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => AuthedAutomationsRoute,
  } as any)
const AuthedAutomationsFormsRoute = AuthedAutomationsFormsRouteImport.update({
  id: '/forms',
  path: '/forms',
  getParentRoute: () => AuthedAutomationsRoute,
} as any)
const AuthedAutomationsFlowsRoute = AuthedAutomationsFlowsRouteImport.update({
  id: '/flows',
  path: '/flows',
  getParentRoute: () => AuthedAutomationsRoute,
} as any)
const AuthedAgendaNuevaRoute = AuthedAgendaNuevaRouteImport.update({
  id: '/agenda_/nueva',
  path: '/agenda/nueva',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAgendaPageIdRoute = AuthedAgendaPageIdRouteImport.update({
  id: '/agenda_/$pageId',
  path: '/agenda/$pageId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAutomationsTemplatesNewRoute =
  AuthedAutomationsTemplatesNewRouteImport.update({
    id: '/templates_/new',
    path: '/templates/new',
    getParentRoute: () => AuthedAutomationsRoute,
  } as any)
const AuthedAutomationsTemplatesTemplateIdRoute =
  AuthedAutomationsTemplatesTemplateIdRouteImport.update({
    id: '/templates_/$templateId',
    path: '/templates/$templateId',
    getParentRoute: () => AuthedAutomationsRoute,
  } as any)
const AuthedAutomationsFormsNewRoute =
  AuthedAutomationsFormsNewRouteImport.update({
    id: '/forms_/new',
    path: '/forms/new',
    getParentRoute: () => AuthedAutomationsRoute,
  } as any)
const AuthedAutomationsFormsFormIdRoute =
  AuthedAutomationsFormsFormIdRouteImport.update({
    id: '/forms_/$formId',
    path: '/forms/$formId',
    getParentRoute: () => AuthedAutomationsRoute,
  } as any)
const AuthedAutomationsFlowsNewRoute =
  AuthedAutomationsFlowsNewRouteImport.update({
    id: '/flows_/new',
    path: '/flows/new',
    getParentRoute: () => AuthedAutomationsRoute,
  } as any)
const AuthedAutomationsFlowsFlowIdRoute =
  AuthedAutomationsFlowsFlowIdRouteImport.update({
    id: '/flows_/$flowId',
    path: '/flows/$flowId',
    getParentRoute: () => AuthedAutomationsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/admins': typeof AuthedAdminsRoute
  '/agenda': typeof AuthedAgendaRoute
  '/automations': typeof AuthedAutomationsRouteWithChildren
  '/chatbot': typeof AuthedChatbotRoute
  '/clientes': typeof AuthedClientesRoute
  '/cms': typeof AuthedCmsRoute
  '/contacts': typeof AuthedContactsRoute
  '/crm': typeof AuthedCrmRoute
  '/google-ads': typeof AuthedGoogleAdsRoute
  '/inbox': typeof AuthedInboxRoute
  '/oportunidades': typeof AuthedOportunidadesRoute
  '/oportunidades-bandeja': typeof AuthedOportunidadesBandejaRoute
  '/pipelines': typeof AuthedPipelinesRoute
  '/planes': typeof AuthedPlanesRoute
  '/reports': typeof AuthedReportsRoute
  '/schemas': typeof AuthedSchemasRoute
  '/screenshots': typeof AuthedScreenshotsRoute
  '/settings': typeof AuthedSettingsRoute
  '/tasks': typeof AuthedTasksRoute
  '/team': typeof AuthedTeamRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/agenda/$pageId': typeof AuthedAgendaPageIdRoute
  '/agenda/nueva': typeof AuthedAgendaNuevaRoute
  '/automations/flows': typeof AuthedAutomationsFlowsRoute
  '/automations/forms': typeof AuthedAutomationsFormsRoute
  '/automations/templates': typeof AuthedAutomationsTemplatesRoute
  '/clientes/$id': typeof AuthedClientesIdRoute
  '/configuracion/agentes': typeof AuthedConfiguracionAgentesRoute
  '/configuracion/correo': typeof AuthedConfiguracionCorreoRoute
  '/contacts/$contactId': typeof AuthedContactsContactIdRoute
  '/oportunidades/$leadId': typeof AuthedOportunidadesLeadIdRoute
  '/agenda/$tenant/$slug': typeof AgendaTenantSlugRoute
  '/agenda/gestionar/$token': typeof AgendaGestionarTokenRoute
  '/automations/flows/$flowId': typeof AuthedAutomationsFlowsFlowIdRoute
  '/automations/flows/new': typeof AuthedAutomationsFlowsNewRoute
  '/automations/forms/$formId': typeof AuthedAutomationsFormsFormIdRoute
  '/automations/forms/new': typeof AuthedAutomationsFormsNewRoute
  '/automations/templates/$templateId': typeof AuthedAutomationsTemplatesTemplateIdRoute
  '/automations/templates/new': typeof AuthedAutomationsTemplatesNewRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/admins': typeof AuthedAdminsRoute
  '/agenda': typeof AuthedAgendaRoute
  '/automations': typeof AuthedAutomationsRouteWithChildren
  '/chatbot': typeof AuthedChatbotRoute
  '/clientes': typeof AuthedClientesRoute
  '/cms': typeof AuthedCmsRoute
  '/contacts': typeof AuthedContactsRoute
  '/crm': typeof AuthedCrmRoute
  '/google-ads': typeof AuthedGoogleAdsRoute
  '/inbox': typeof AuthedInboxRoute
  '/oportunidades': typeof AuthedOportunidadesRoute
  '/oportunidades-bandeja': typeof AuthedOportunidadesBandejaRoute
  '/pipelines': typeof AuthedPipelinesRoute
  '/planes': typeof AuthedPlanesRoute
  '/reports': typeof AuthedReportsRoute
  '/schemas': typeof AuthedSchemasRoute
  '/screenshots': typeof AuthedScreenshotsRoute
  '/settings': typeof AuthedSettingsRoute
  '/tasks': typeof AuthedTasksRoute
  '/team': typeof AuthedTeamRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/': typeof AuthedIndexRoute
  '/agenda/$pageId': typeof AuthedAgendaPageIdRoute
  '/agenda/nueva': typeof AuthedAgendaNuevaRoute
  '/automations/flows': typeof AuthedAutomationsFlowsRoute
  '/automations/forms': typeof AuthedAutomationsFormsRoute
  '/automations/templates': typeof AuthedAutomationsTemplatesRoute
  '/clientes/$id': typeof AuthedClientesIdRoute
  '/configuracion/agentes': typeof AuthedConfiguracionAgentesRoute
  '/configuracion/correo': typeof AuthedConfiguracionCorreoRoute
  '/contacts/$contactId': typeof AuthedContactsContactIdRoute
  '/oportunidades/$leadId': typeof AuthedOportunidadesLeadIdRoute
  '/agenda/$tenant/$slug': typeof AgendaTenantSlugRoute
  '/agenda/gestionar/$token': typeof AgendaGestionarTokenRoute
  '/automations/flows/$flowId': typeof AuthedAutomationsFlowsFlowIdRoute
  '/automations/flows/new': typeof AuthedAutomationsFlowsNewRoute
  '/automations/forms/$formId': typeof AuthedAutomationsFormsFormIdRoute
  '/automations/forms/new': typeof AuthedAutomationsFormsNewRoute
  '/automations/templates/$templateId': typeof AuthedAutomationsTemplatesTemplateIdRoute
  '/automations/templates/new': typeof AuthedAutomationsTemplatesNewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/_authed/admins': typeof AuthedAdminsRoute
  '/_authed/agenda': typeof AuthedAgendaRoute
  '/_authed/automations': typeof AuthedAutomationsRouteWithChildren
  '/_authed/chatbot': typeof AuthedChatbotRoute
  '/_authed/clientes': typeof AuthedClientesRoute
  '/_authed/cms': typeof AuthedCmsRoute
  '/_authed/contacts': typeof AuthedContactsRoute
  '/_authed/crm': typeof AuthedCrmRoute
  '/_authed/google-ads': typeof AuthedGoogleAdsRoute
  '/_authed/inbox': typeof AuthedInboxRoute
  '/_authed/oportunidades': typeof AuthedOportunidadesRoute
  '/_authed/oportunidades-bandeja': typeof AuthedOportunidadesBandejaRoute
  '/_authed/pipelines': typeof AuthedPipelinesRoute
  '/_authed/planes': typeof AuthedPlanesRoute
  '/_authed/reports': typeof AuthedReportsRoute
  '/_authed/schemas': typeof AuthedSchemasRoute
  '/_authed/screenshots': typeof AuthedScreenshotsRoute
  '/_authed/settings': typeof AuthedSettingsRoute
  '/_authed/tasks': typeof AuthedTasksRoute
  '/_authed/team': typeof AuthedTeamRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/agenda_/$pageId': typeof AuthedAgendaPageIdRoute
  '/_authed/agenda_/nueva': typeof AuthedAgendaNuevaRoute
  '/_authed/automations/flows': typeof AuthedAutomationsFlowsRoute
  '/_authed/automations/forms': typeof AuthedAutomationsFormsRoute
  '/_authed/automations/templates': typeof AuthedAutomationsTemplatesRoute
  '/_authed/clientes_/$id': typeof AuthedClientesIdRoute
  '/_authed/configuracion/agentes': typeof AuthedConfiguracionAgentesRoute
  '/_authed/configuracion/correo': typeof AuthedConfiguracionCorreoRoute
  '/_authed/contacts_/$contactId': typeof AuthedContactsContactIdRoute
  '/_authed/oportunidades_/$leadId': typeof AuthedOportunidadesLeadIdRoute
  '/agenda/$tenant/$slug': typeof AgendaTenantSlugRoute
  '/agenda/gestionar/$token': typeof AgendaGestionarTokenRoute
  '/_authed/automations/flows_/$flowId': typeof AuthedAutomationsFlowsFlowIdRoute
  '/_authed/automations/flows_/new': typeof AuthedAutomationsFlowsNewRoute
  '/_authed/automations/forms_/$formId': typeof AuthedAutomationsFormsFormIdRoute
  '/_authed/automations/forms_/new': typeof AuthedAutomationsFormsNewRoute
  '/_authed/automations/templates_/$templateId': typeof AuthedAutomationsTemplatesTemplateIdRoute
  '/_authed/automations/templates_/new': typeof AuthedAutomationsTemplatesNewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/admins'
    | '/agenda'
    | '/automations'
    | '/chatbot'
    | '/clientes'
    | '/cms'
    | '/contacts'
    | '/crm'
    | '/google-ads'
    | '/inbox'
    | '/oportunidades'
    | '/oportunidades-bandeja'
    | '/pipelines'
    | '/planes'
    | '/reports'
    | '/schemas'
    | '/screenshots'
    | '/settings'
    | '/tasks'
    | '/team'
    | '/reset-password/$token'
    | '/agenda/$pageId'
    | '/agenda/nueva'
    | '/automations/flows'
    | '/automations/forms'
    | '/automations/templates'
    | '/clientes/$id'
    | '/configuracion/agentes'
    | '/configuracion/correo'
    | '/contacts/$contactId'
    | '/oportunidades/$leadId'
    | '/agenda/$tenant/$slug'
    | '/agenda/gestionar/$token'
    | '/automations/flows/$flowId'
    | '/automations/flows/new'
    | '/automations/forms/$formId'
    | '/automations/forms/new'
    | '/automations/templates/$templateId'
    | '/automations/templates/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/login'
    | '/admins'
    | '/agenda'
    | '/automations'
    | '/chatbot'
    | '/clientes'
    | '/cms'
    | '/contacts'
    | '/crm'
    | '/google-ads'
    | '/inbox'
    | '/oportunidades'
    | '/oportunidades-bandeja'
    | '/pipelines'
    | '/planes'
    | '/reports'
    | '/schemas'
    | '/screenshots'
    | '/settings'
    | '/tasks'
    | '/team'
    | '/reset-password/$token'
    | '/'
    | '/agenda/$pageId'
    | '/agenda/nueva'
    | '/automations/flows'
    | '/automations/forms'
    | '/automations/templates'
    | '/clientes/$id'
    | '/configuracion/agentes'
    | '/configuracion/correo'
    | '/contacts/$contactId'
    | '/oportunidades/$leadId'
    | '/agenda/$tenant/$slug'
    | '/agenda/gestionar/$token'
    | '/automations/flows/$flowId'
    | '/automations/flows/new'
    | '/automations/forms/$formId'
    | '/automations/forms/new'
    | '/automations/templates/$templateId'
    | '/automations/templates/new'
  id:
    | '__root__'
    | '/_authed'
    | '/forgot-password'
    | '/login'
    | '/_authed/admins'
    | '/_authed/agenda'
    | '/_authed/automations'
    | '/_authed/chatbot'
    | '/_authed/clientes'
    | '/_authed/cms'
    | '/_authed/contacts'
    | '/_authed/crm'
    | '/_authed/google-ads'
    | '/_authed/inbox'
    | '/_authed/oportunidades'
    | '/_authed/oportunidades-bandeja'
    | '/_authed/pipelines'
    | '/_authed/planes'
    | '/_authed/reports'
    | '/_authed/schemas'
    | '/_authed/screenshots'
    | '/_authed/settings'
    | '/_authed/tasks'
    | '/_authed/team'
    | '/reset-password/$token'
    | '/_authed/'
    | '/_authed/agenda_/$pageId'
    | '/_authed/agenda_/nueva'
    | '/_authed/automations/flows'
    | '/_authed/automations/forms'
    | '/_authed/automations/templates'
    | '/_authed/clientes_/$id'
    | '/_authed/configuracion/agentes'
    | '/_authed/configuracion/correo'
    | '/_authed/contacts_/$contactId'
    | '/_authed/oportunidades_/$leadId'
    | '/agenda/$tenant/$slug'
    | '/agenda/gestionar/$token'
    | '/_authed/automations/flows_/$flowId'
    | '/_authed/automations/flows_/new'
    | '/_authed/automations/forms_/$formId'
    | '/_authed/automations/forms_/new'
    | '/_authed/automations/templates_/$templateId'
    | '/_authed/automations/templates_/new'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordTokenRoute: typeof ResetPasswordTokenRoute
  AgendaTenantSlugRoute: typeof AgendaTenantSlugRoute
  AgendaGestionarTokenRoute: typeof AgendaGestionarTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/reset-password/$token': {
      id: '/reset-password/$token'
      path: '/reset-password/$token'
      fullPath: '/reset-password/$token'
      preLoaderRoute: typeof ResetPasswordTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/team': {
      id: '/_authed/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof AuthedTeamRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/tasks': {
      id: '/_authed/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AuthedTasksRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings': {
      id: '/_authed/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedSettingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/screenshots': {
      id: '/_authed/screenshots'
      path: '/screenshots'
      fullPath: '/screenshots'
      preLoaderRoute: typeof AuthedScreenshotsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/schemas': {
      id: '/_authed/schemas'
      path: '/schemas'
      fullPath: '/schemas'
      preLoaderRoute: typeof AuthedSchemasRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/reports': {
      id: '/_authed/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthedReportsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/planes': {
      id: '/_authed/planes'
      path: '/planes'
      fullPath: '/planes'
      preLoaderRoute: typeof AuthedPlanesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/pipelines': {
      id: '/_authed/pipelines'
      path: '/pipelines'
      fullPath: '/pipelines'
      preLoaderRoute: typeof AuthedPipelinesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/oportunidades-bandeja': {
      id: '/_authed/oportunidades-bandeja'
      path: '/oportunidades-bandeja'
      fullPath: '/oportunidades-bandeja'
      preLoaderRoute: typeof AuthedOportunidadesBandejaRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/oportunidades': {
      id: '/_authed/oportunidades'
      path: '/oportunidades'
      fullPath: '/oportunidades'
      preLoaderRoute: typeof AuthedOportunidadesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/inbox': {
      id: '/_authed/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AuthedInboxRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/google-ads': {
      id: '/_authed/google-ads'
      path: '/google-ads'
      fullPath: '/google-ads'
      preLoaderRoute: typeof AuthedGoogleAdsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/crm': {
      id: '/_authed/crm'
      path: '/crm'
      fullPath: '/crm'
      preLoaderRoute: typeof AuthedCrmRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/contacts': {
      id: '/_authed/contacts'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof AuthedContactsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/cms': {
      id: '/_authed/cms'
      path: '/cms'
      fullPath: '/cms'
      preLoaderRoute: typeof AuthedCmsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/clientes': {
      id: '/_authed/clientes'
      path: '/clientes'
      fullPath: '/clientes'
      preLoaderRoute: typeof AuthedClientesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/chatbot': {
      id: '/_authed/chatbot'
      path: '/chatbot'
      fullPath: '/chatbot'
      preLoaderRoute: typeof AuthedChatbotRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/automations': {
      id: '/_authed/automations'
      path: '/automations'
      fullPath: '/automations'
      preLoaderRoute: typeof AuthedAutomationsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agenda': {
      id: '/_authed/agenda'
      path: '/agenda'
      fullPath: '/agenda'
      preLoaderRoute: typeof AuthedAgendaRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admins': {
      id: '/_authed/admins'
      path: '/admins'
      fullPath: '/admins'
      preLoaderRoute: typeof AuthedAdminsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/agenda/gestionar/$token': {
      id: '/agenda/gestionar/$token'
      path: '/agenda/gestionar/$token'
      fullPath: '/agenda/gestionar/$token'
      preLoaderRoute: typeof AgendaGestionarTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agenda/$tenant/$slug': {
      id: '/agenda/$tenant/$slug'
      path: '/agenda/$tenant/$slug'
      fullPath: '/agenda/$tenant/$slug'
      preLoaderRoute: typeof AgendaTenantSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/oportunidades_/$leadId': {
      id: '/_authed/oportunidades_/$leadId'
      path: '/oportunidades/$leadId'
      fullPath: '/oportunidades/$leadId'
      preLoaderRoute: typeof AuthedOportunidadesLeadIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/contacts_/$contactId': {
      id: '/_authed/contacts_/$contactId'
      path: '/contacts/$contactId'
      fullPath: '/contacts/$contactId'
      preLoaderRoute: typeof AuthedContactsContactIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/configuracion/correo': {
      id: '/_authed/configuracion/correo'
      path: '/configuracion/correo'
      fullPath: '/configuracion/correo'
      preLoaderRoute: typeof AuthedConfiguracionCorreoRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/configuracion/agentes': {
      id: '/_authed/configuracion/agentes'
      path: '/configuracion/agentes'
      fullPath: '/configuracion/agentes'
      preLoaderRoute: typeof AuthedConfiguracionAgentesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/clientes_/$id': {
      id: '/_authed/clientes_/$id'
      path: '/clientes/$id'
      fullPath: '/clientes/$id'
      preLoaderRoute: typeof AuthedClientesIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/automations/templates': {
      id: '/_authed/automations/templates'
      path: '/templates'
      fullPath: '/automations/templates'
      preLoaderRoute: typeof AuthedAutomationsTemplatesRouteImport
      parentRoute: typeof AuthedAutomationsRoute
    }
    '/_authed/automations/forms': {
      id: '/_authed/automations/forms'
      path: '/forms'
      fullPath: '/automations/forms'
      preLoaderRoute: typeof AuthedAutomationsFormsRouteImport
      parentRoute: typeof AuthedAutomationsRoute
    }
    '/_authed/automations/flows': {
      id: '/_authed/automations/flows'
      path: '/flows'
      fullPath: '/automations/flows'
      preLoaderRoute: typeof AuthedAutomationsFlowsRouteImport
      parentRoute: typeof AuthedAutomationsRoute
    }
    '/_authed/agenda_/nueva': {
      id: '/_authed/agenda_/nueva'
      path: '/agenda/nueva'
      fullPath: '/agenda/nueva'
      preLoaderRoute: typeof AuthedAgendaNuevaRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agenda_/$pageId': {
      id: '/_authed/agenda_/$pageId'
      path: '/agenda/$pageId'
      fullPath: '/agenda/$pageId'
      preLoaderRoute: typeof AuthedAgendaPageIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/automations/templates_/new': {
      id: '/_authed/automations/templates_/new'
      path: '/templates/new'
      fullPath: '/automations/templates/new'
      preLoaderRoute: typeof AuthedAutomationsTemplatesNewRouteImport
      parentRoute: typeof AuthedAutomationsRoute
    }
    '/_authed/automations/templates_/$templateId': {
      id: '/_authed/automations/templates_/$templateId'
      path: '/templates/$templateId'
      fullPath: '/automations/templates/$templateId'
      preLoaderRoute: typeof AuthedAutomationsTemplatesTemplateIdRouteImport
      parentRoute: typeof AuthedAutomationsRoute
    }
    '/_authed/automations/forms_/new': {
      id: '/_authed/automations/forms_/new'
      path: '/forms/new'
      fullPath: '/automations/forms/new'
      preLoaderRoute: typeof AuthedAutomationsFormsNewRouteImport
      parentRoute: typeof AuthedAutomationsRoute
    }
    '/_authed/automations/forms_/$formId': {
      id: '/_authed/automations/forms_/$formId'
      path: '/forms/$formId'
      fullPath: '/automations/forms/$formId'
      preLoaderRoute: typeof AuthedAutomationsFormsFormIdRouteImport
      parentRoute: typeof AuthedAutomationsRoute
    }
    '/_authed/automations/flows_/new': {
      id: '/_authed/automations/flows_/new'
      path: '/flows/new'
      fullPath: '/automations/flows/new'
      preLoaderRoute: typeof AuthedAutomationsFlowsNewRouteImport
      parentRoute: typeof AuthedAutomationsRoute
    }
    '/_authed/automations/flows_/$flowId': {
      id: '/_authed/automations/flows_/$flowId'
      path: '/flows/$flowId'
      fullPath: '/automations/flows/$flowId'
      preLoaderRoute: typeof AuthedAutomationsFlowsFlowIdRouteImport
      parentRoute: typeof AuthedAutomationsRoute
    }
  }
}

interface AuthedAutomationsRouteChildren {
  AuthedAutomationsFlowsRoute: typeof AuthedAutomationsFlowsRoute
  AuthedAutomationsFormsRoute: typeof AuthedAutomationsFormsRoute
  AuthedAutomationsTemplatesRoute: typeof AuthedAutomationsTemplatesRoute
  AuthedAutomationsFlowsFlowIdRoute: typeof AuthedAutomationsFlowsFlowIdRoute
  AuthedAutomationsFlowsNewRoute: typeof AuthedAutomationsFlowsNewRoute
  AuthedAutomationsFormsFormIdRoute: typeof AuthedAutomationsFormsFormIdRoute
  AuthedAutomationsFormsNewRoute: typeof AuthedAutomationsFormsNewRoute
  AuthedAutomationsTemplatesTemplateIdRoute: typeof AuthedAutomationsTemplatesTemplateIdRoute
  AuthedAutomationsTemplatesNewRoute: typeof AuthedAutomationsTemplatesNewRoute
}

const AuthedAutomationsRouteChildren: AuthedAutomationsRouteChildren = {
  AuthedAutomationsFlowsRoute: AuthedAutomationsFlowsRoute,
  AuthedAutomationsFormsRoute: AuthedAutomationsFormsRoute,
  AuthedAutomationsTemplatesRoute: AuthedAutomationsTemplatesRoute,
  AuthedAutomationsFlowsFlowIdRoute: AuthedAutomationsFlowsFlowIdRoute,
  AuthedAutomationsFlowsNewRoute: AuthedAutomationsFlowsNewRoute,
  AuthedAutomationsFormsFormIdRoute: AuthedAutomationsFormsFormIdRoute,
  AuthedAutomationsFormsNewRoute: AuthedAutomationsFormsNewRoute,
  AuthedAutomationsTemplatesTemplateIdRoute:
    AuthedAutomationsTemplatesTemplateIdRoute,
  AuthedAutomationsTemplatesNewRoute: AuthedAutomationsTemplatesNewRoute,
}

const AuthedAutomationsRouteWithChildren =
  AuthedAutomationsRoute._addFileChildren(AuthedAutomationsRouteChildren)

interface AuthedRouteChildren {
  AuthedAdminsRoute: typeof AuthedAdminsRoute
  AuthedAgendaRoute: typeof AuthedAgendaRoute
  AuthedAutomationsRoute: typeof AuthedAutomationsRouteWithChildren
  AuthedChatbotRoute: typeof AuthedChatbotRoute
  AuthedClientesRoute: typeof AuthedClientesRoute
  AuthedCmsRoute: typeof AuthedCmsRoute
  AuthedContactsRoute: typeof AuthedContactsRoute
  AuthedCrmRoute: typeof AuthedCrmRoute
  AuthedGoogleAdsRoute: typeof AuthedGoogleAdsRoute
  AuthedInboxRoute: typeof AuthedInboxRoute
  AuthedOportunidadesRoute: typeof AuthedOportunidadesRoute
  AuthedOportunidadesBandejaRoute: typeof AuthedOportunidadesBandejaRoute
  AuthedPipelinesRoute: typeof AuthedPipelinesRoute
  AuthedPlanesRoute: typeof AuthedPlanesRoute
  AuthedReportsRoute: typeof AuthedReportsRoute
  AuthedSchemasRoute: typeof AuthedSchemasRoute
  AuthedScreenshotsRoute: typeof AuthedScreenshotsRoute
  AuthedSettingsRoute: typeof AuthedSettingsRoute
  AuthedTasksRoute: typeof AuthedTasksRoute
  AuthedTeamRoute: typeof AuthedTeamRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedAgendaPageIdRoute: typeof AuthedAgendaPageIdRoute
  AuthedAgendaNuevaRoute: typeof AuthedAgendaNuevaRoute
  AuthedClientesIdRoute: typeof AuthedClientesIdRoute
  AuthedConfiguracionAgentesRoute: typeof AuthedConfiguracionAgentesRoute
  AuthedConfiguracionCorreoRoute: typeof AuthedConfiguracionCorreoRoute
  AuthedContactsContactIdRoute: typeof AuthedContactsContactIdRoute
  AuthedOportunidadesLeadIdRoute: typeof AuthedOportunidadesLeadIdRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAdminsRoute: AuthedAdminsRoute,
  AuthedAgendaRoute: AuthedAgendaRoute,
  AuthedAutomationsRoute: AuthedAutomationsRouteWithChildren,
  AuthedChatbotRoute: AuthedChatbotRoute,
  AuthedClientesRoute: AuthedClientesRoute,
  AuthedCmsRoute: AuthedCmsRoute,
  AuthedContactsRoute: AuthedContactsRoute,
  AuthedCrmRoute: AuthedCrmRoute,
  AuthedGoogleAdsRoute: AuthedGoogleAdsRoute,
  AuthedInboxRoute: AuthedInboxRoute,
  AuthedOportunidadesRoute: AuthedOportunidadesRoute,
  AuthedOportunidadesBandejaRoute: AuthedOportunidadesBandejaRoute,
  AuthedPipelinesRoute: AuthedPipelinesRoute,
  AuthedPlanesRoute: AuthedPlanesRoute,
  AuthedReportsRoute: AuthedReportsRoute,
  AuthedSchemasRoute: AuthedSchemasRoute,
  AuthedScreenshotsRoute: AuthedScreenshotsRoute,
  AuthedSettingsRoute: AuthedSettingsRoute,
  AuthedTasksRoute: AuthedTasksRoute,
  AuthedTeamRoute: AuthedTeamRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedAgendaPageIdRoute: AuthedAgendaPageIdRoute,
  AuthedAgendaNuevaRoute: AuthedAgendaNuevaRoute,
  AuthedClientesIdRoute: AuthedClientesIdRoute,
  AuthedConfiguracionAgentesRoute: AuthedConfiguracionAgentesRoute,
  AuthedConfiguracionCorreoRoute: AuthedConfiguracionCorreoRoute,
  AuthedContactsContactIdRoute: AuthedContactsContactIdRoute,
  AuthedOportunidadesLeadIdRoute: AuthedOportunidadesLeadIdRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordTokenRoute: ResetPasswordTokenRoute,
  AgendaTenantSlugRoute: AgendaTenantSlugRoute,
  AgendaGestionarTokenRoute: AgendaGestionarTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
